import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";

const ProtectedRoute = () => {
  const { user } = useContext(GlobalContext);

  if (!user) {
    return <Navigate to="/gateway" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
